<template>
  <div class="login-page" :style="backgroundStyle">
    <div class="login-overlay"></div>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div id="content" class="login-shell">
      <div class="card card-style login-card">
        <div class="content login-content">
          <div class="logo-wrap">
            <img
              src="../assets/images/logo_rio_.png"
              alt="logo"
              class="logo-rio"
            />
            <img
              src="../assets/images/logo-samu-192.png"
              alt="logo samu"
              class="logo-samu"
            />
          </div>

          <!-- <h1 class="text-center font-800 font-30 mb-2">Sign In</h1> -->
          <p class="login-title">
            Samu 192 Digital
          </p>
          <p class="login-subtitle">
            Para utilizar o aplicativo, autentique-se na plataforma GOV.BR do
            Governo Federal, clicando no botão abaixo.
          </p>

          <div class="gov-button-wrap">
            <button class="br-sign-in" type="button" @click="loginGov">
              Entrar com&nbsp;<img
                src="https://www.gov.br/++theme++padrao_govbr/img/govbr-colorido-b.png"
                alt="gov.br"
              />
            </button>
          </div>

          <div class="version-label">Versão: 3.5.39</div>
          <a class="terms-link" target="_blank" :href="privacyPolicyUrl">
            Termos de uso e política de privacidade
          </a>
        </div>
      </div>
    </div>
    <b-modal
      id="modalConsentimento"
      title="Termos de Uso"
      @ok="confirmarConsentimento(true)"
      @cancel="confirmarConsentimento(false)"
      hide-footer
    >
      <div>
        <div class="row justify-content-center">
          <div style="text-align: center !important">
            <img
              src="../assets/images/logo_samu.png"
              alt="logo"
              height="55"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
            <img
              src="../assets/images/image.png"
              alt="logo"
              height="55"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
          </div>
          <div class="col-12" style="text-align: left">
            <strong>IMPORTANTE:</strong>
            <p>
              Estes termos e condições gerais de uso aplicam-se às atividades
              relativas ao aplicativo denominado SAMU Capital-RJ Digital,
              desenvolvido pela empresa IT4D Soluções LTDA, registrada sob o
              CNPJ 04.510.666/0001-40 e tem sua sede localizada na Avenida
              Yojiro Takaoka, 4384 - Alphaville, Santana de Parnaiba - SP,
              06.541-038. O aplicatido SAMU Capital-RJ Digital foi desenvolvido
              com o intuito de disponibilizar a comunicação, de forma ágil e
              segura, de usuários que necessitados ao serviço prestados pelo
              SAMU Capital do Rio de Janeiro.
            </p>
          </div>
          <div v-if="showWarning" class="alert alert-warning mt-3">
            É obrigatório aceitar os termos!
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          style="margin-right: 5px"
          variant="success"
          @click="confirmarConsentimento(true)"
          >Aceitar</b-button
        >
        <b-button variant="danger" @click="confirmarConsentimento(false)"
          >Rejeitar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      forgetPassword: false,
      backgroundImages: [
        "1.jpg",
        "4.jpg",
        "5.jpg",
        "6.jpeg",
        "9.jpeg",
        "14.jpeg"
      ],
      currentBackgroundIndex: 0,
      new_path: "/dashboard",
      email: "",
      password: "",
      forgot: {
        email: ""
      },
      isLoading: false,
      loadingColor: "#5D9CEC",
      showWarning: false,
      showPassword: false
    };
  },
  computed: {
    backgroundStyle() {
      const imagePath = require(`@/assets/images/login/${
        this.backgroundImages[this.currentBackgroundIndex]
      }`);
      return {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      };
    },
    privacyPolicyUrl() {
      const baseUrl = (this.$store.state.url || "").replace(/\/+$/, "");
      return `${baseUrl}/politica_privacidade.html`;
    }
  },
  created() {
    this.currentBackgroundIndex = Math.floor(
      Math.random() * this.backgroundImages.length
    );
  },
  methods: {
    async loginGov() {
      const clientId = "p-samudigitalrio.fs.rj.gov.br";
      const scope =
        "openid+email+profile+phone+govbr_confiabilidades+govbr_confiabilidades_idtoken";

      // gerar verifier
      const codeVerifier = [...crypto.getRandomValues(new Uint8Array(32))]
        .map(b => ("0" + b.toString(16)).slice(-2))
        .join("");

      // gerar nonce e state obrigatorios
      const nonce = [...crypto.getRandomValues(new Uint8Array(6))]
        .map(b => ("0" + b.toString(16)).slice(-2))
        .join("");
      const state = [...crypto.getRandomValues(new Uint8Array(8))]
        .map(b => ("0" + b.toString(16)).slice(-2))
        .join("");

      // gerar challenge: BASE64URL-ENCODE(SHA256(ASCII(code_verifier)))
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = await crypto.subtle.digest("SHA-256", data);

      const codeChallenge = btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");

      // salva o verifier no backend indexado pelo state (TTL 5 min)
      // inclui a URL atual para redirecionar de volta após o login
      await axios.post(this.$store.state.api + "oauth/pkce-store", {
        state,
        code_verifier: codeVerifier,
        redirect_back: window.location.href
      });

      // redirect_uri identico ao cadastrado no gov.br (sem query params)
      const redirectUri = encodeURIComponent(
        "https://api.samudigitalrio.fs.rj.gov.br/api/v1/webhook-return"
      );

      const url =
        "https://sso.acesso.gov.br/authorize" +
        "?response_type=code" +
        "&client_id=" +
        encodeURIComponent(clientId) +
        "&scope=" +
        scope +
        "&redirect_uri=" +
        redirectUri +
        "&nonce=" +
        encodeURIComponent(nonce) +
        "&state=" +
        encodeURIComponent(state) +
        "&code_challenge=" +
        codeChallenge +
        "&code_challenge_method=S256";

      window.location.href = url;
    },
    esqueciSenha() {
      this.forgetPassword = !this.forgetPassword;
      console.log(this.forgetPassword);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    changeBackgroundImage() {
      setInterval(() => {
        this.currentBackgroundIndex =
          (this.currentBackgroundIndex + 1) % this.backgroundImages.length;
      }, 5000);
    },
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    openModal() {
      this.showWarning = false; // Reseta o aviso ao abrir o modal
      this.$bvModal.show("modalConsentimento");
    },
    confirmarConsentimento(aceitar) {
      if (aceitar) {
        this.$router.push({ path: this.new_path }); // Chama a função de login se aceitar
      } else {
        this.showWarning = true; // Mostra o aviso se rejeitar
      }
    },
    enviarEmail() {
      this.isLoading = true;
      const api = this.$store.state.api + "esqueci_senha";

      axios
        .post(api, {
          cpf: this.cpf
        })
        .then(response => {
          this.$message("Sucesso", "E-mail enviado com sucesso", "success");
          this.forgetPassword = false;
          this.isLoading = false;
        })
        .catch(error => {
          this.$message(null, error.response.data, "error");
          this.isLoading = false;
        });
    },
    login() {
      this.isLoading = true;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          cpf: this.cpf,
          senha: this.password
        })
        .then(response => {
          // Salvar dados do usuário no Vuex
          this.$store.commit("auth", response.data.access_token);
          this.$store.commit("usuario_id", response.data.usuario_id);
          this.$store.commit("usuario_nome", response.data.usuario_nome);

          // Redefinir estado de carregamento
          this.isLoading = false;

          // Abrir o modal de consentimento após login bem-sucedido
          this.openModal();
        })
        .catch(() => {
          // Exibir mensagem de erro e redefinir estado de carregamento
          this.isLoading = false;
          this.$message("Erro", "Credenciais incorretas", "error");
        });
    },
    forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email
        })
        .then(response => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  components: { Loading },
  props: {},
  mounted: function() {
    const self = this;

    var url = self.$route.fullPath.split("?url=%2F");
    if (url[1]) {
      self.new_path = url[1];
    }

    const params = new URLSearchParams(window.location.search);

    const token = params.get("token");
    const usuario_id = params.get("usuario_id");
    const usuario_nome = params.get("usuario_nome");

    if (token) {
      this.$store.commit("auth", token);
      this.$store.commit("usuario_id", usuario_id);
      this.$store.commit("usuario_nome", usuario_nome);
      this.$router.replace("/dashboard");
    }
  }
};
</script>
<style scoped>
.login-page {
  min-height: 100vh;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(
      circle at 20% 20%,
      rgba(214, 88, 44, 0.25),
      transparent 45%
    ),
    linear-gradient(145deg, rgba(9, 24, 44, 0.72), rgba(12, 40, 74, 0.68));
}

.login-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 430px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.58);
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.35);
}

.login-content {
  padding: 30px 24px 28px;
  display: flex;
  flex-direction: column;
}

.version-label {
  margin-top: auto;
  padding-top: 16px;
  text-align: center;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  letter-spacing: 0.3px;
}

.terms-link a {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #2f5f9f !important;
  text-decoration: underline;
  display: block;
}

.terms-link {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #2f5f9f;
  text-decoration: underline;
  display: block;
}

.terms-link:hover,
.terms-link:focus {
  color: #224b82;
}

.logo-wrap {
  text-align: center;
}

.login-title {
  margin: 0;
  margin-top: 8px;
  text-align: center;
  color: #000000;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.login-subtitle {
  margin-top: 10px;
  margin-bottom: 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  line-height: 1.45;
  font-size: 14px;
}

.gov-button-wrap {
  margin: 30px 0 26px;
  display: flex;
  justify-content: center;
}

.create-account-link {
  display: block;
  text-align: center;
  color: #f3f6ff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.create-account-link:hover {
  color: #ffffff;
  opacity: 0.85;
}

input {
  color: black;
}

label {
  margin-bottom: -3px;
  margin-top: 3px;
}

.login a {
  color: #ffffff;
}

/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

@media (max-width: 480px) {
  .login-content {
    padding: 24px 18px 22px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 13px;
  }
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.br-sign-in,
.br-button.sign-in {
  --button-radius: 100em;
  --button-xsmall: 24px;
  --button-small: 32px;
  --button-medium: 40px;
  --button-large: 48px;
  --button-size: var(--button-medium);
  align-items: center;
  background-color: transparent;
  border: 0;
  border-radius: var(--button-radius);
  color: var(--interactive);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--font-size-scale-up-01);
  font-weight: var(--font-weight-semi-bold);
  height: var(--button-size);
  justify-content: center;
  overflow: hidden;
  padding: 0 var(--spacing-scale-3x);
  position: relative;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
}
.br-sign-in.block,
.br-button.sign-in.block {
  width: 100%;
}
@media (min-width: 576px) {
  .br-sign-in.block-sm,
  .br-button.sign-in.block-sm {
    width: 100%;
  }
  .br-sign-in.auto-sm,
  .br-button.sign-in.auto-sm {
    width: auto;
  }
}
@media (min-width: 992px) {
  .br-sign-in.block-md,
  .br-button.sign-in.block-md {
    width: 100%;
  }
  .br-sign-in.auto-md,
  .br-button.sign-in.auto-md {
    width: auto;
  }
}
@media (min-width: 1280px) {
  .br-sign-in.block-lg,
  .br-button.sign-in.block-lg {
    width: 100%;
  }
  .br-sign-in.auto-lg,
  .br-button.sign-in.auto-lg {
    width: auto;
  }
}
@media (min-width: 1600px) {
  .br-sign-in.block-xl,
  .br-button.sign-in.block-xl {
    width: 100%;
  }
  .br-sign-in.auto-xl,
  .br-button.sign-in.auto-xl {
    width: auto;
  }
}
.br-sign-in.circle,
.br-sign-in[circle],
.br-sign-in.is-circle,
.br-button.sign-in.circle,
.br-button.sign-in[circle],
.br-button.sign-in.is-circle {
  border-radius: 50%;
  padding: 0;
  width: var(--button-size);
}
.br-sign-in.xsmall,
.br-sign-in[xsmall],
.br-sign-in.is-xsmall,
.br-button.sign-in.xsmall,
.br-button.sign-in[xsmall],
.br-button.sign-in.is-xsmall {
  --button-size: var(--button-xsmall);
}
.br-sign-in.small,
.br-sign-in[small],
.br-sign-in.is-small,
.br-button.sign-in.small,
.br-button.sign-in[small],
.br-button.sign-in.is-small {
  --button-size: var(--button-small);
}
.br-sign-in.medium,
.br-sign-in[medium],
.br-sign-in.is-medium,
.br-button.sign-in.medium,
.br-button.sign-in[medium],
.br-button.sign-in.is-medium {
  --button-size: var(--button-medium);
}
.br-sign-in.large,
.br-sign-in[large],
.br-sign-in.is-large,
.br-button.sign-in.large,
.br-button.sign-in[large],
.br-button.sign-in.is-large {
  --button-size: var(--button-large);
}
.br-sign-in.primary,
.br-sign-in[primary],
.br-sign-in.is-primary,
.br-button.sign-in.primary,
.br-button.sign-in[primary],
.br-button.sign-in.is-primary {
  --interactive-rgb: var(--color-dark-rgb);
  background-color: var(--interactive-light);
  color: var(--color-dark);
}
.br-sign-in.secondary,
.br-sign-in[secondary],
.br-sign-in.is-secondary,
.br-button.sign-in.secondary,
.br-button.sign-in[secondary],
.br-button.sign-in.is-secondary {
  background-color: var(--background-light);
  border: 1px solid var(--interactive);
}
.br-sign-in.danger,
.br-sign-in[danger],
.br-sign-in.is-danger,
.br-button.sign-in.danger,
.br-button.sign-in[danger],
.br-button.sign-in.is-danger {
  background-color: var(--danger);
  --interactive-rgb: var(--color-dark-rgb);
  color: var(--color-dark);
}
.br-sign-in.success,
.br-sign-in[success],
.br-sign-in.is-success,
.br-button.sign-in.success,
.br-button.sign-in[success],
.br-button.sign-in.is-success {
  background-color: var(--success);
  --interactive-rgb: var(--color-dark-rgb);
  color: var(--color-dark);
}
.br-sign-in.warning,
.br-sign-in[warning],
.br-sign-in.is-warning,
.br-button.sign-in.warning,
.br-button.sign-in[warning],
.br-button.sign-in.is-warning {
  background-color: var(--warning);
  --interactive-rgb: var(--color-light-rgb);
  color: var(--color-light);
}
.br-sign-in.info,
.br-sign-in[info],
.br-sign-in.is-info,
.br-button.sign-in.info,
.br-button.sign-in[info],
.br-button.sign-in.is-info {
  background-color: var(--info);
  --interactive-rgb: var(--color-dark-rgb);
  color: var(--color-dark);
}
.br-sign-in:disabled,
.br-button.sign-in:disabled {
  cursor: not-allowed;
}
.br-sign-in:not(:disabled),
.br-button.sign-in:not(:disabled) {
  --focus-offset: var(--spacing-scale-half);
}
.br-sign-in:not(:disabled):focus,
.br-button.sign-in:not(:disabled):focus {
  outline: none;
}
.br-sign-in:not(:disabled).focus-visible,
.br-sign-in:not(:disabled):focus-visible,
.br-button.sign-in:not(:disabled).focus-visible,
.br-button.sign-in:not(:disabled):focus-visible {
  outline-color: var(--focus);
  outline-offset: var(--focus-offset);
  outline-style: var(--focus-style);
  outline-width: var(--focus-width);
}
.br-sign-in:not(:disabled):not(:disabled):hover,
.br-button.sign-in:not(:disabled):not(:disabled):hover {
  background-image: linear-gradient(
    rgba(var(--interactive-rgb), var(--hover)),
    rgba(var(--interactive-rgb), var(--hover))
  );
}
.br-sign-in:not(:disabled):not(:disabled):active,
.br-button.sign-in:not(:disabled):not(:disabled):active {
  background-image: linear-gradient(
    rgba(var(--interactive-rgb), var(--pressed)),
    rgba(var(--interactive-rgb), var(--pressed))
  );
}
.br-sign-in.active,
.br-sign-in.is-active,
.br-sign-in[active],
.br-button.sign-in.active,
.br-button.sign-in.is-active,
.br-button.sign-in[active] {
  --hover: var(--hover-dark);
  background-color: var(--active);
  color: var(--color-dark);
}
.br-sign-in.loading,
.br-button.sign-in.loading {
  color: transparent !important;
  cursor: progress;
}
.br-sign-in.loading:not(:disabled):hover,
.br-button.sign-in.loading:not(:disabled):hover {
  background-image: none;
}
.br-sign-in.loading::before,
.br-button.sign-in.loading::before {
  border-color: var(--interactive) var(--interactive) transparent;
  border-style: solid;
}
.br-sign-in.loading.primary::before,
.br-sign-in.loading.danger::before,
.br-sign-in.loading.success::before,
.br-sign-in.loading.info::before,
.br-button.sign-in.loading.primary::before,
.br-button.sign-in.loading.danger::before,
.br-button.sign-in.loading.success::before,
.br-button.sign-in.loading.info::before {
  border-color: var(--background) var(--background) transparent;
}
.br-sign-in.inverted,
.br-sign-in.is-inverted,
.br-sign-in[inverted],
.br-sign-in.dark-mode,
.br-button.sign-in.inverted,
.br-button.sign-in.is-inverted,
.br-button.sign-in[inverted],
.br-button.sign-in.dark-mode {
  --color: var(--color-dark);
  --color-rgb: var(--color-dark-rgb);
  --text-color: var(--color-dark);
  --interactive: var(--interactive-dark);
  --interactive-rgb: var(--interactive-dark-rgb);
  --visited: var(--visited-dark);
  --hover: var(--hover-dark);
  --pressed: var(--pressed-dark);
  --focus-color: var(--focus-color-dark);
  --focus: var(--focus-color-dark);
  color: var(--interactive-dark);
}
.br-sign-in.inverted.primary,
.br-sign-in.inverted[primary],
.br-sign-in.inverted.is-primary,
.br-sign-in.is-inverted.primary,
.br-sign-in.is-inverted[primary],
.br-sign-in.is-inverted.is-primary,
.br-sign-in[inverted].primary,
.br-sign-in[inverted][primary],
.br-sign-in[inverted].is-primary,
.br-sign-in.dark-mode.primary,
.br-sign-in.dark-mode[primary],
.br-sign-in.dark-mode.is-primary,
.br-button.sign-in.inverted.primary,
.br-button.sign-in.inverted[primary],
.br-button.sign-in.inverted.is-primary,
.br-button.sign-in.is-inverted.primary,
.br-button.sign-in.is-inverted[primary],
.br-button.sign-in.is-inverted.is-primary,
.br-button.sign-in[inverted].primary,
.br-button.sign-in[inverted][primary],
.br-button.sign-in[inverted].is-primary,
.br-button.sign-in.dark-mode.primary,
.br-button.sign-in.dark-mode[primary],
.br-button.sign-in.dark-mode.is-primary {
  --interactive-rgb: var(--background-dark-rgb);
  background-color: var(--interactive-dark);
  color: var(--background-dark);
}
.br-sign-in.inverted.secondary,
.br-sign-in.inverted[secondary],
.br-sign-in.inverted.is-secondary,
.br-sign-in.is-inverted.secondary,
.br-sign-in.is-inverted[secondary],
.br-sign-in.is-inverted.is-secondary,
.br-sign-in[inverted].secondary,
.br-sign-in[inverted][secondary],
.br-sign-in[inverted].is-secondary,
.br-sign-in.dark-mode.secondary,
.br-sign-in.dark-mode[secondary],
.br-sign-in.dark-mode.is-secondary,
.br-button.sign-in.inverted.secondary,
.br-button.sign-in.inverted[secondary],
.br-button.sign-in.inverted.is-secondary,
.br-button.sign-in.is-inverted.secondary,
.br-button.sign-in.is-inverted[secondary],
.br-button.sign-in.is-inverted.is-secondary,
.br-button.sign-in[inverted].secondary,
.br-button.sign-in[inverted][secondary],
.br-button.sign-in[inverted].is-secondary,
.br-button.sign-in.dark-mode.secondary,
.br-button.sign-in.dark-mode[secondary],
.br-button.sign-in.dark-mode.is-secondary {
  background-color: var(--background-dark);
}
.br-sign-in.inverted.active,
.br-sign-in.is-inverted.active,
.br-sign-in[inverted].active,
.br-sign-in.dark-mode.active,
.br-button.sign-in.inverted.active,
.br-button.sign-in.is-inverted.active,
.br-button.sign-in[inverted].active,
.br-button.sign-in.dark-mode.active {
  --hover: var(--hover-light);
  --interactive-rgb: var(--active-rgb);
  background-color: var(--background-light);
  color: var(--active);
}
.br-sign-in,
.br-button.sign-in {
  --background: var(--gray-2);
  --sign-in-img: 20px;
  background-color: var(--background);
  padding: 0 var(--spacing-scale-2x);
}
.br-sign-in img,
.br-button.sign-in img {
  max-height: var(--sign-in-img);
}
.br-sign-in.inverted,
.br-sign-in.is-inverted,
.br-sign-in[inverted],
.br-sign-in.dark-mode,
.br-button.sign-in.inverted,
.br-button.sign-in.is-inverted,
.br-button.sign-in[inverted],
.br-button.sign-in.dark-mode {
  --background: var(--background-dark);
}

/*# sourceMappingURL=signin.css.map*/
</style>



// WEBPACK FOOTER //
// src/components/Login.vue